export const CALENDAR_SCREEN_HIGHLIGHT = '#575DCD';
export const MEET_SCREEN_HIGHLIGHT = '#F97066';
export const TASKS_SCREEN_HIGHLIGHT = '#028FEF';
